import {AxiosResponse} from "axios";
import * as React from "react";
import {Popup} from "../popup/popup";
import {HttpErrorModel} from "../../../models/httpError";
import {ReactComponent as RemoveIcon} from "../../../../statics/icons/icon_remove.svg";
import {Api} from "../../../../helpers/api";
import {HttpError} from "../httpError/httpError";

interface RemovePopupProps {
    content: JSX.Element;
    header: string;
    secondHeader: string;
    actionText: string;
    displayPopup: boolean;
    confirm: () => void;
    closePopup: () => void;
    response: AxiosResponse<HttpErrorModel[] | any> | undefined;
    httpErrorMessage: string;
    isWaiting?: boolean;
}

export default function RemovePopup(props: RemovePopupProps): React.ReactElement {
    return (
        <Popup
            open={props.displayPopup}
            className="remove-popup popup-with-secondary-button-color"
            header={props.header}
            secondHeader={props.secondHeader}
            icon={<RemoveIcon/>}
            content={props.content}
            actionText={props.actionText}
            action={props.confirm}
            cancel={props.closePopup}
            testId="remove-popup"
            isWaiting={props.isWaiting}
            httpError={
                <>
                    {!Api.isSuccess(props.response) && (
                        <HttpError
                            response={props.response}
                            cause={props.httpErrorMessage}
                        />
                    )}
                </>
            }
        />
    );
}
